import React from "react";
import Header from "../components/Header";
import ModalList from "../components/ModalList";

function Main({ menuVisible, toggleMenu }) {
    if (!menuVisible) return null;

    return (
        <>
            <div className="fixed inset-0 z-[89]" onClick={toggleMenu} />
            <div className="absolute top-[calc(100%+10px)] right-0 z-[100] bg-white rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.12)] border border-[#EDEDED] w-[260px] p-3">
                <Header />
                <ModalList />
            </div>
        </>
    );
}

export default Main;
